import type { Gradients } from ".";
import type { PipeFrictionContext } from "../d";

export function calculateGradientsMist(
  context: PipeFrictionContext
): Gradients {
  const {
    fluidPropertiesContext: {
      fluidProperties: {
        gasDensityLBMFT3,
        liquidSuperficialVelocityFTSEC,
        liquidDensityLBMFT3
      },
      fluidFrictionProperties: { pipeDiameterNumber, gasVelocityNumber }
    },
    VSG,
    epsilonD
  } = context;
  // D281: 0
  const slipCorrelation = 0;

  // D283: =((1/(4*LOG10(0.27*D305))^2)+0.067*D305^1.73)*4
  const frictionFactor =
    (1 / (4 * Math.log(0.27 * epsilonD)) ** 2 + 0.067 * epsilonD ** 1.73) * 4;

  // D285: =D62/D63
  const densityInfluenceNumber = gasDensityLBMFT3 / liquidDensityLBMFT3;

  // D291: =2*D289*D287*(D174^2)/D178
  const frictionGradient =
    (2 * frictionFactor * densityInfluenceNumber * gasVelocityNumber ** 2) /
    pipeDiameterNumber;

  // D307: =D307/D150
  const gasVelocityRatio = VSG / liquidSuperficialVelocityFTSEC;

  // D289: =1/(1+D301)
  const liquidHoldup = 1 / (1 + gasVelocityRatio);

  // D299: =(D293*D63+(1-D255)*D62)/(144)
  const staticGradient =
    (liquidHoldup * liquidDensityLBMFT3 +
      (1 - liquidHoldup) * liquidDensityLBMFT3) /
    144;

  return {
    slipCorrelation,
    frictionFactor,
    frictionGradient,
    liquidHoldup,
    staticGradient
  };
}
